module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionLzlj.bf1e6a38.png";